import angular from 'angular';
import sectionsLibraryService from './../../../SectionsLibraryService';
import toolbarService from './../../../../Toolbar/ToolbarService';

import template from './imageText.mjml';
import MjmlTemplateExtractor from './../../../Mjml/MjmlTemplateExtractor';
import './imageText.scss';
import Image from "../../../../ConfigParameters/ConfigParameters/Image";
import TextContent from "../../../../ConfigParameters/ConfigParameters/TextContent";
import TextColor from "../../../../ConfigParameters/ConfigParameters/TextColor";
import BackgroundColor from "../../../../ConfigParameters/ConfigParameters/BackgroundColor";
import Paddings from "../../../../ConfigParameters/ConfigCollections/Paddings";
import ConfigParameter from "../../../../ConfigParameters/ConfigParameter";

const creatorMailSectionImageText = {
    bindings: {
        elementModel: '=',
    },
    template: MjmlTemplateExtractor(template),
    controller: function (ToolbarService) {
        //let imageFirst = false;

        this.editorOptions = {
            toolbar: [
                {name: 'styles', items: ['Format', 'FontSize']},
                {name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', '-', 'RemoveFormat']},
                '/',
                {name: 'links', items: ['Link','Unlink']},
                {name: 'colors', items: ['TextColor', 'BGColor']},
                {name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', '-', 'CreatePlaceholder']}
            ]
        };

        let defaultConfig = ToolbarService.getSectionDefaultSchema('imageText');

        this.$onInit = () => {
            this.elementModel = angular.copy(angular.extend(defaultConfig, this.elementModel));
        };
    }
};

export default angular.module('cms.creator.mail.section-image-text', [sectionsLibraryService, toolbarService])
    .run(function (SectionsLibraryService, ToolbarService, gettext) {

        SectionsLibraryService.registerSection({
            icon: 'art_track',
            type: 'imageText',
            label: gettext('Text with image'),
            group: 'mail',
            groups: {
                mainConfig: {
                    label: gettext('Main config'),
                    isOpen: true,
                    type: 'mainConfig'
                },
                position: {
                    label: gettext('Position'),
                    isOpen: false,
                    type: 'position'
                }
            }
        });

        ToolbarService.registerSectionSchema('imageText', {
            ...(new Image()),
            ...(new ConfigParameter('imagePosition', 'selectionButtons', gettext('Image position'), 'position', 'right', null,
                [{value: 'left', template: '<i class="fa fa-align-left">'},
                {value: 'right', template: '<i class="fa fa-align-right"></i>'}])),
            ...(new TextContent()),
            ...(new TextColor()),
            ...(new BackgroundColor()),
            ...(new Paddings({value: 15, unit: 'px'},{value: 30, unit: 'px'},['px'])),
            ...(new ConfigParameter('imgPadding', 'number', gettext('Padding (image)'), 'position', {value: 10, unit: 'px'}, ['px']) ),
            ...(new ConfigParameter('textPadding', 'number', gettext('Padding (text)'), 'position', {value: 10, unit: 'px'}, ['px']) )
        });

    })
    .component('cmsCreatorMailSectionImageText', creatorMailSectionImageText).name;


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/SectionsLibrary/Sections/Mail/ImageText/ImageText.js